import React, { useState } from 'react';
import { ChevronDownIcon, EyeOffIcon } from 'lucide-react';
import type { FieldGroup } from '../../types/disclosure';
interface NotApplicableGroupsProps {
  groups: FieldGroup[];
  sectionId: string;
}
export function NotApplicableGroups({
  groups,
  sectionId
}: NotApplicableGroupsProps) {
  const [open, setOpen] = useState(false);
  if (groups.length === 0) return null;
  return <section aria-label="Conditional groups that did not apply" className="overflow-hidden rounded-md border border-slate-200 bg-slate-50" data-id="element-25" data-mp="8lrgrqdt98zv">
      <button type="button" aria-expanded={open} aria-controls={`${sectionId}-na-panel`} onClick={() => setOpen(value => !value)} className="flex w-full items-center justify-between gap-3 px-3 py-2 text-left transition-colors hover:bg-slate-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-600" data-id="element-26" data-mp="djawkuq5pttx">
        <span className="flex min-w-0 items-center gap-2" data-id="element-27" data-mp="1y0fsrqihooxd">
          <EyeOffIcon className="h-3.5 w-3.5 shrink-0 text-slate-400" aria-hidden="true" data-id="element-28" data-mp="2q2plq84x89om" />
          <span className="text-[11px] font-semibold uppercase tracking-wide text-slate-600" data-id="element-29" data-mp="2l4xsnasjihiu">
            {groups.length} conditional {groups.length === 1 ? 'group' : 'groups'} did not apply
          </span>
        </span>
        <span className="flex items-center gap-1.5 text-[11px] font-medium text-slate-500" data-id="element-30" data-mp="2uviqux4axk18">
          {open ? 'Hide' : 'Show'}
          <ChevronDownIcon className={`h-4 w-4 shrink-0 text-slate-400 transition-transform ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-31" data-mp="276preqoh0u1v" />
        </span>
      </button>

      {open && <ul id={`${sectionId}-na-panel`} className="divide-y divide-slate-200 border-t border-slate-200 bg-white" data-id="element-32" data-mp="2c3pyn4x242uk">
          {groups.map(group => <li key={group.id} className="grid gap-x-6 gap-y-1.5 px-3 py-2.5 lg:grid-cols-[minmax(0,260px)_minmax(0,1fr)]" data-id="element-33" data-mp="3sk2j90t1ogyk">
              <div className="min-w-0" data-id="element-34" data-mp="3ula1eojrgge7">
                <p className="text-[13px] font-medium text-slate-700" data-id="element-35" data-mp="3uoftmcnorye5">{group.title}</p>
                {group.condition && <p className="text-[11px] text-slate-500" data-id="element-36" data-mp="8ebu7x41hmyy">Shows when {group.condition}</p>}
              </div>
              <div className="min-w-0" data-id="element-37" data-mp="dcn3o6qf9vgn">
                {group.applicabilityNote && <p className="text-[11px] text-slate-500" data-id="element-38" data-mp="3bwmvy4xo9p03">{group.applicabilityNote}</p>}
                <ul className="mt-1 flex flex-wrap gap-1" data-id="element-39" data-mp="3gvgbe2wirq2w">
                  {group.fields.map(field => <li key={field.api + field.label} className="rounded bg-slate-50 px-1.5 py-0.5 text-[11px] text-slate-500 ring-1 ring-inset ring-slate-200" data-id="element-40" data-mp="3ls6smtk28rpw">
                      {field.label}
                    </li>)}
                </ul>
              </div>
            </li>)}
        </ul>}
    </section>;
}